import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CheckRideRequestEntity, CheckRideScheduleHoldEntity } from '../../../../meta-data/app-meta-data.service';
import { ScheduleHoldUtilService } from '../../services/schedule-hold-util.service';
import { ApplicantRepositoryService } from '../../../applicant/services/applicant-repository.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { ScheduleHoldResultAction } from '../../../examiner/models/schedule-hold-result.model';



@DwComponent({
  key: 'checkride-schedule-hold-info',
  name: 'Checkride Schedule Hold Info',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-schedule-hold-info',
  template: `
    <div class="schedule-hold-info" *ngIf="message">
      <div class="pull-left">
        <i class="fa fa-exclamation-circle fa-2x dw-orange pull-left"></i> <div class="schedule-hold-message pull-left">{{message}}</div>
      </div>
      <div class="pull-right">
        <span class="schedule-hold-expiration-time">{{timeUntilExpiration}}</span>
      </div>
    </div>
  `
})
export class ScheduleHoldInfoComponent extends DwSectionBaseComponent implements OnDestroy {
  formApi: DwMetaDataFormApi;
  scheduleHold: CheckRideScheduleHoldEntity;
  message: string;
  minutesUntilExpiration: number;
  secondsUtilExpiration: number;
  timeUntilExpiration: string;
  checkRideRequest: CheckRideRequestEntity;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private scheduleHoldUtilService: ScheduleHoldUtilService,
    private dateTimeUtilService: DateTimeUtilService,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = dwMetaDataFormStateService.state.formApi;
  }
 
  setupComponentComplete(): void {
    if (!this.scheduleHoldUtilService.requiresScheduleHold({} as any)) {
      console.warn('Schedule hold is not required for this checkride');
      return;
    }

    this.scheduleHoldUtilService.getScheduleHoldSubjectChanged().subscribe((result: any) => {
      this.setupScheduleHoldInfo();
    });

    this.setupScheduleHoldInfo();

    this.formApi.getFormDataChanges().subscribe((data: any) => {
      this.checkRideRequest = data;
      this.setupInitialScheduleHold();
    });

    this.checkRideRequest = this.formApi.getFormData();
    this.setupInitialScheduleHold();
  }

  intervalHandle: any = null;

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }

    if (this.scheduleHold) {
     // console.log('Cancelling schedule hold');
      this.scheduleHoldUtilService.cancelScheduleHold(this.scheduleHold, this.checkRideRequest)
        .subscribe((result) => {
          // Don't care about the result
        });
    }
  }

  initialScheduleHoldSetup = false;

  setupInitialScheduleHold(): void {

    if (this.initialScheduleHoldSetup) {
      return;
    }
    
    if (!this.checkRideRequest) {
      return;
    }

    if (!this.examinerRepositoryService.requireCheckrideAvailabilityCheck(this.checkRideRequest, this.formApi.formMode, true)) {
      return;
    }

    // Schedule a hold

    this.initialScheduleHoldSetup = true;


    this.scheduleHoldUtilService.startScheduleHold(this.checkRideRequest)
      .subscribe((result) => {
        if (result.ResultAction == ScheduleHoldResultAction.holdStarted) {
            return;
        }

        this.scheduleHoldUtilService.returnToSearch(this.checkRideRequest, this.formApi, result.ErrorMessage);
      });

    if (this.checkRideRequest.CheckRideScheduleHold) {
      this.setupScheduleHoldInfo();
    }

  }

  setupIntervalUpdate(): void {
    this.intervalHandle = setInterval(() => {
      if (!this.scheduleHold) {
        return;
      }

      this.setExpirationTime(this.scheduleHold);

    }, 1000);
  }


  setExpirationTime(scheduleHold: CheckRideScheduleHoldEntity) {
    if (!scheduleHold) {
      return;
    }

    const currentDateTime = this.dateTimeUtilService.getCurrentDateTime();

    this.secondsUtilExpiration = this.dateTimeUtilService.calcDurationSeconds(currentDateTime, scheduleHold.ExpirationDateTime);

    this.timeUntilExpiration = this.dateTimeUtilService.formatDuration(this.secondsUtilExpiration);

    if (this.secondsUtilExpiration <= 0) {
      this.message = 'Your booking slot has expired.';

      this.timeUntilExpiration = '';
      clearInterval(this.intervalHandle);

      this.scheduleHoldUtilService.returnToSearch(this.checkRideRequest, this.formApi, this.message);
    }
  }

  setupScheduleHoldInfo(): void {
    this.scheduleHold = this.scheduleHoldUtilService.getScheduleHold();

    if (!this.scheduleHold) {
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle);
      }
      return;
    }

    this.setupIntervalUpdate();
    
    const expirationDateTime = this.dateTimeUtilService.formatDateTimeToLocal(this.scheduleHold.ExpirationDateTime);

    this.message = `We are holding this booking slot for you until ${expirationDateTime}`;
  }

}
